export const PARTY_TYPE_CODE_TYPES = [
  'PARTY_TYPE_MASTER',
  'ACEISF_PARTY_TYPE',
  'ACEISF5_PARTY_TYPE',
  'ACE_HW_PARTY_TYPE'
]

export const PARTY_IDENTIFIER_CODE_TYPES = [
  'PARTY_IDENTIFIER_CODE',
  'FDA_PN_PARTY_IDENTIFIER_CODE',
  'ACE_HW_IM_PARTY_IDN_CODE',
  'ACE_HW_GC_PARTY_IDN_CODE',
  'ACEISF_IM_CN_DOC_TYPE',
  'ACEISF_DOC_TYPE',
  'ACEISF_IMP_HOL_DOC_TYPE',
  'ACEISF5_DOC_TYPE'
]

// Label as "CODE - Description" (e.g. "IM - Importer of Record").
export function codeDescriptionLabel(record) {
  return `${record.code} - ${record.descriptionEn}`
}

// The IN filter spans multiple codeTypes, so the same code+description can
// come back more than once (e.g. "CN" exists in both PARTY_TYPE_MASTER and
// ACEISF_PARTY_TYPE). Dedupe by code before applying the usual search-text
// filtering, since providing a custom filterOptions replaces MUI's default.
export function dedupeAndFilterCodeOptions(options, inputValue) {
  const seenCodes = new Set()
  const deduped = options.filter((option) => {
    if (seenCodes.has(option.value)) return false
    seenCodes.add(option.value)
    return true
  })
  const search = inputValue.toLowerCase()
  return deduped.filter((option) => option.label.toLowerCase().includes(search))
}
